import { Controller } from "@hotwired/stimulus"

// The feed's mention search, collapsed to an icon button in the page header so
// it never competes for width with the variable-length source label in the
// filter bar. The form carries the active filter params as hidden fields, so
// submitting search preserves whatever source / time / status is engaged.
export default class extends Controller {
  static targets = ["button", "field", "input"]

  // Toggle via inline display: the collapsed button carries `inline-flex`, and
  // both it and `hidden` are display utilities, so a `hidden` class would lose
  // to `inline-flex` on CSS source order. An inline style always wins.
  expand() {
    this.buttonTarget.style.display = "none"
    this.fieldTarget.style.display = ""
    this.inputTarget.focus()
  }

  // Collapse back to the icon only when empty; a live query keeps the field open.
  collapse() {
    if (this.inputTarget.value.trim()) return
    this.fieldTarget.style.display = "none"
    this.buttonTarget.style.display = ""
  }

  // The inline dismiss control: clear-and-resubmit when a query is active,
  // otherwise just fold the field away.
  dismiss() {
    if (this.inputTarget.value.trim()) {
      this.inputTarget.value = ""
      this.element.requestSubmit()
    } else {
      this.collapse()
    }
  }
}
